import { render, staticRenderFns } from "./Tagged.vue?vue&type=template&id=4a8b888a&scoped=true"
import script from "./Tagged.vue?vue&type=script&lang=js"
export * from "./Tagged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8b888a",
  null
  
)

export default component.exports